import { CATEGORY_THEME } from "../categoryHeaders";

// Readable accent RGB (matches tailwind tokens) for the small header accent bar.
const ACCENT_RGB = {
  cyan: "32,184,205",
  teal: "19,124,139",
  eblue: "45,127,249",
  violet: "124,111,229",
  success: "53,183,121",
  warn: "233,162,59",
  critical: "216,88,88",
};

// Larger, banner-style category header: eyebrow + accent bar, prominent title,
// a short technical descriptor line, and a compact row of tool/method chips.
// Text contrast adapts to light/dark sections via existing CSS; the accent only
// drives the bar + the live background (rendered separately via CategoryBackground).
export default function CategoryHeader({ id, eyebrow, title, description, category }) {
  const theme = CATEGORY_THEME[category] || {};
  const chips = theme.chips || [];
  const a = ACCENT_RGB[theme.accent] || ACCENT_RGB.cyan;
  const b = ACCENT_RGB[theme.accent2] || ACCENT_RGB.teal;
  return (
    <div className="relative max-w-4xl" id={id} data-testid={id ? `category-header-${id}` : undefined}>
      <div className="flex items-center gap-3.5">
        <span
          aria-hidden="true"
          className="h-[4px] w-12 rounded-full"
          style={{ background: `linear-gradient(90deg, rgba(${a},1), rgba(${b},0.7))` }}
        />
        <p className="overline-label text-xs sm:text-sm" data-testid={id ? `${id}-overline` : undefined}>
          {eyebrow}
        </p>
      </div>
      <h2 className="font-sans tracking-tight text-5xl sm:text-6xl lg:text-7xl text-paper mt-6">{title}</h2>
      {description && <p className="text-steel text-lg md:text-xl mt-6 leading-relaxed">{description}</p>}
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-7" data-testid={id ? `category-header-${id}-chips` : undefined}>
          {chips.map((c) => (
            <span
              key={c}
              className="tech-tag"
              style={{ borderColor: `rgba(${a},0.45)`, boxShadow: `inset 0 0 0 1px rgba(${a},0.08)` }}
            >
              {c}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
